<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="900px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <div>
      <div class="images-container">
        <div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('INDEX.table_label_image') || '图片' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <div>
              <el-upload
                id="uploader"
                ref="uploader"
                multiple
                action="#"
                :file-list="listImageFile"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="uploadChange"
                accept=".jpeg,.jpg,.png,.gif"
              >
                <el-button class="ml-2" style="font-size: 14px;" type="text">
                  {{ $l('INDEX.btn_upload_image') || '上传图片' }}
                </el-button>
              </el-upload>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap block" v-if="!isEmpty">
          <div v-for="(item, index) in listImage" :key="index">
            <div class="image-box">
              <el-image
                style="width: 100%; height: 100%"
                fit="scale-down"
                :src="item.displayImageUrl"
                :preview-src-list="listImageUrl"
              ></el-image>
              <div class="shadow">
                <div>
                  <span @click="onImagePreview(index)">
                    <i class="el-icon-zoom-in"></i
                  ></span>
                  <span @click="onImageCheck(item)" class="ml-2">
                    <i class="el-icon-check"></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isEmpty" class="empty-image">
          <div style="text-align: center">
            <img src="/image/static/img/nodata.png" />
            <p class="no-data mt-2">
              {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
            </p>
          </div>
        </div>
      </div>
      <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
        <img
          v-for="item in listImageUrl"
          :src="item || '/image/static/img/nopic.jpg'"
          :key="item"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    proofingCode: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '图片维护' },
  },
  data() {
    return {
      listImage: [],
      listImageFile: [],
      uploadFileMaxLimit: 10,
    }
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.listImage.map((item) => item.displayImageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.proofingCode) return
      const res = await this.$api
        .customerProofingImageListApi({ proofingCode: this.proofingCode })
        .catch(() => null)
      this.listImage = res.body.data
    },
    uploadChange(file) {
      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg =
          (this.$l('INDEX.evg_sku_limit_selection') || '当前限制选择') +
          `  ${this.uploadFileMaxLimit}  ` +
          (this.$l('INDEX.evg_sku_limit_picture') || '张图片') +
          ',' +
          (this.$l('INDEX.tips_selected_this_time') || '本次选择了') +
          `  ${fileCount}  ` +
          (this.$l('INDEX.evg_sku_limit_picture') || '张图片')

        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }
      this.listImageFile.push(file)
      if (this.listImageFile.length !== fileCount) return false
      this.upload()
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    onImageDel({ proofingImgCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .customerProofingImageDelApi({ proofingImgCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.getData()
        this.$emit('reload')
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
      })
    },
    async onImageCheck({ evgSkuImgCode, displayImageCode, displayImageUrl }) {
      this.$emit('setImage', {
        evgSkuImgCode,
        displayImageCode,
        displayImageUrl,
      })
    },
    close() {
      this.$emit('update:visible', false)
    },

    async upload() {
      if (!this.listImageFile || !this.listImageFile.length) {
        this.$message.warning(
          this.$l('INDEX.evg_sku_limit_please_select_image') ||
            '请选择您需要上传的图片！'
        )
        return
      }

      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        this.clearFiles()
        return
      }

      const params = { proofingCode: this.proofingCode, listImage }

      const res = await this.$api
        .customerProofingImageUploadApi(params)
        .catch(() => null)
      this.loadingClose()
      this.clearFiles()
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.$emit('reload')
      this.getData()
    },
    uploadImages() {
      if (!this.listImageFile || !this.listImageFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImageFile.map(({ raw }) => {
        return this.$api
          .SYS_UPLOAD(raw)
          .then((res) => ({
            originImageCode: res.body.fileId,
            originImageUrl: res.body.url,
            originImageSpec: raw.type,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImageFile = []
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.images-container {
  height: calc(100vh - 460px);
  min-height: 460px;
  overflow: auto;
}

.empty-image {
  height: calc(100vh - 510px);
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
